import React from 'react';
import { uiAppLogger } from 'apps/sigma2-ui/src/lib/logging';
import { ErrorFallback } from 'apps/sigma2-ui/src/components/ErrorFallback';

interface ErrorBoundaryProps {
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  message: string;
}

// This can't be a function component because it uses getDerivedStateFromError: https://reactjs.org/docs/error-boundaries.html#introducing-error-boundaries
export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state = { hasError: false, message: '' };

  constructor(props: ErrorBoundaryProps) {
    super(props);
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI
    return { hasError: !!error, message: error?.message ?? error?.toString() };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
    uiAppLogger.error(error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? <ErrorFallback message={this.state.message} />
      );
    }

    return this.props.children;
  }
}
